// extracted by mini-css-extract-plugin
export default {"square":"ProductivityGraph_square__sged-"};